<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>{{ $t('common.editar') }}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>Ayuda de pantalla</f7-nav-title>
      <f7-nav-title v-else sliding>{{ $t('common.nueva') }}</f7-nav-title>
      <f7-nav-right>
        <f7-button color="teal" icon-f7="eye" text="Vista previa" class="display-flex" @click="abrirVistaPrevia"></f7-button>
        <template v-if="!readonly">
          <f7-button v-if="id" color="gray" @click="cancelar">{{ $t('common.cancelar') }}</f7-button>
          <f7-button
            fill
            icon-f7="floppy_disk"
            :text="$t('common.guardar')"
            class="display-flex"
            @click="$refs.rform.saveItem()"
          ></f7-button>
        </template>
        <template v-else>
          <f7-button color="blue" @click="readonly = false">{{ $t('common.editar') }}</f7-button>
          <f7-button color="red" @click="deleteItem">{{ $t('common.eliminar') }}</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{ rform }"
      :itemId="id"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="Ayuda"
      :default-data="{activa: true, autoAbrir: false, rutas: []}"
    >
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="50">
              <ul>
                <r-input
                  floating-label
                  outline
                  label="Clave"
                  :form="rform"
                  type="text"
                  name="clave"
                ></r-input>
                <r-input
                  floating-label
                  outline
                  label="Título"
                  :form="rform"
                  type="text"
                  name="titulo"
                ></r-input>
              </ul>
            </f7-col>
            <f7-col width="100" medium="50">
              <ul>
                <r-input
                  floating-label
                  outline
                  label="Se abre sola la primera vez"
                  :form="rform"
                  type="check"
                  name="autoAbrir"
                ></r-input>
                <r-input
                  floating-label
                  outline
                  label="Activa"
                  :form="rform"
                  type="check"
                  name="activa"
                ></r-input>
              </ul>
            </f7-col>
          </f7-row>

          <div class="label-group">Rutas de la pantalla</div>
          <p class="ayuda-nota">
            El patrón de la ruta del router, no la url: <code>/itemclasificacion/</code> cubre también sus
            formularios (gana la coincidencia exacta y, si no hay, el prefijo más largo).
          </p>
          <div class="ayuda-rutas">
            <span v-for="(ruta, i) in (rform.formData.rutas || [])" :key="'ruta'+i" class="chip">
              <span class="chip-label">{{ ruta }}</span>
              <a v-if="!readonly" href="#" class="chip-delete" @click.prevent="quitarRuta(rform, i)"></a>
            </span>
            <span v-if="!(rform.formData.rutas || []).length" class="ayuda-nota">Sin rutas: sólo se podrá resolver por clave.</span>
          </div>
          <div v-if="!readonly" class="ayuda-rutas-add">
            <input type="text" v-model="nuevaRuta" placeholder="/mipantalla/" @keyup.enter="anadirRuta(rform)" />
            <f7-button small fill @click="anadirRuta(rform)">Añadir ruta</f7-button>
          </div>
        </f7-card-content>
      </f7-card>

      <f7-card class="padding-vertical-half padding-right">
        <f7-card-content>
          <div class="label-group">Contenido</div>
          <p class="ayuda-nota">
            El CSS se acota automáticamente al contenedor de la ayuda, así que no puede afectar al
            resto de la aplicación; por eso los <code>@import</code> se descartan y la ayuda tiene
            que traer su propio CSS. El JS recibe <code>root</code> (el contenedor) y
            <code>app</code> ($f7), y puede devolver una función de limpieza que se ejecuta al cerrar.
          </p>
          <div class="ayuda-modo-html">
            <f7-segmented raised>
              <f7-button :active="modoHtml === 'codigo'" @click="cambiarModoHtml('codigo')">Código HTML</f7-button>
              <f7-button :active="modoHtml === 'visual'" @click="cambiarModoHtml('visual')">Visual</f7-button>
            </f7-segmented>
            <f7-link
              v-if="modoHtml === 'visual' && htmlAntesDeVisual !== null && !readonly"
              class="margin-left"
              color="orange"
              @click="restaurarHtmlPrevio()"
            >Restaurar el HTML de antes</f7-link>
            <span v-if="modoHtml === 'visual'" class="ayuda-nota-inline">
              El editor visual reescribe el HTML a su manera: úsalo para texto con formato, listas y enlaces.
            </span>
          </div>

          <ul class="list list-form no-hairlines">
            <r-code v-if="modoHtml === 'codigo'" :form="rform" name="html" label="HTML" language="markup"></r-code>
            <r-rich-text-input v-else :form="rform" name="html" label="HTML"></r-rich-text-input>
            <r-code :form="rform" name="css" label="CSS" language="css"></r-code>
            <r-code :form="rform" name="js" label="JS" language="js"></r-code>
          </ul>
        </f7-card-content>
      </f7-card>
    </r-form>

    <f7-popup class="popup-ayuda-preview" v-if="previewOpened" :opened="true" @popup:closed="previewOpened = false">
      <f7-page>
        <f7-navbar>
          <f7-nav-title>{{ vistaPrevia && vistaPrevia.titulo ? vistaPrevia.titulo : 'Vista previa' }}</f7-nav-title>
          <f7-nav-right><f7-link popup-close>Cerrar</f7-link></f7-nav-right>
        </f7-navbar>
        <r-ayuda-contenido :ayuda="vistaPrevia"></r-ayuda-contenido>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<style scoped>
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}
.ayuda-nota {
  margin: 4px 20px 8px;
  font-size: 12px;
  color: #777;
}
.ayuda-rutas {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin: 0 20px 8px;
}
.ayuda-rutas-add {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0 20px 8px;
}
.ayuda-modo-html {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 8px 20px 4px;
}
.ayuda-nota-inline {
  font-size: 12px;
  color: #777;
}
.ayuda-rutas-add input {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #d4dde8;
  border-radius: 8px;
  font-size: 13px;
}
</style>

<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rCode from "./../../components/rCode.vue";
import rRichTextInput from "./../../components/rRichTextInput.vue";
import rAyudaContenido from "./../../components/rAyudaContenido.vue";
import Ayuda from "../../js/db/Ayuda.js";
import { riesgosDelEditorVisual } from "../../js/AyudaUtils.js";

export default {
  components: {
    rForm,
    rInput,
    rCode,
    rRichTextInput,
    rAyudaContenido
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      Ayuda,
      readonly: !this.editable,
      nuevaRuta: "",
      previewOpened: false,
      vistaPrevia: null,
      modoHtml: "codigo",
      // El HTML tal y como estaba antes de entrar en visual, por si sólo se quería echar un vistazo.
      htmlAntesDeVisual: null
    };
  },
  methods: {
    /**
     * El editor visual no edita HTML: lo parsea a su modelo y lo vuelve a escribir, así que se lleva
     * por delante lo que no entiende. Se avisa antes, diciendo qué hay en ESTE contenido que se
     * perdería, y se guarda una copia para poder volver atrás si sólo se quería mirar.
     */
    cambiarModoHtml: function (modo) {
      var self = this;
      if (modo === self.modoHtml) return;

      if (modo === "codigo") {
        self.modoHtml = "codigo";
        return;
      }

      var html = self.$refs.rform ? self.$refs.rform.formData.html : "";
      var riesgos = riesgosDelEditorVisual(html);
      if (!riesgos.length || self.readonly) {
        self.entrarEnVisual(html);
        return;
      }

      self.$f7.dialog.confirm(
        "El editor visual reescribe el HTML y se perderían:<br><br>· "
          + riesgos.join("<br>· ")
          + "<br><br>Si esta ayuda tiene script, dejaría de encontrar sus elementos."
          + "<br><br>Podrás deshacerlo con «Restaurar el HTML de antes» mientras no salgas de la pantalla.",
        "Abrir en el editor visual",
        function () { self.entrarEnVisual(html); }
      );
    },
    entrarEnVisual: function (html) {
      this.htmlAntesDeVisual = html || "";
      this.modoHtml = "visual";
    },
    restaurarHtmlPrevio: function () {
      var self = this;
      if (self.htmlAntesDeVisual === null || !self.$refs.rform) return;
      self.$f7.dialog.confirm(
        "Se descarta lo editado en visual y vuelve el HTML que había al abrirlo.",
        "Restaurar",
        function () {
          self.$set(self.$refs.rform.formData, "html", self.htmlAntesDeVisual);
          self.modoHtml = "codigo";
        }
      );
    },
    anadirRuta: function (rform) {
      var ruta = (this.nuevaRuta || "").trim();
      if (!ruta) return;
      if (!rform.formData.rutas) this.$set(rform.formData, "rutas", []);
      if (rform.formData.rutas.indexOf(ruta) === -1) rform.formData.rutas.push(ruta);
      this.nuevaRuta = "";
    },
    quitarRuta: function (rform, i) {
      if (rform.formData.rutas) rform.formData.rutas.splice(i, 1);
    },
    abrirVistaPrevia: function () {
      var datos = this.$refs.rform ? this.$refs.rform.formData : null;
      // Copia: la vista previa no debe reaccionar a cada tecla que se escriba en los editores.
      this.vistaPrevia = datos ? JSON.parse(JSON.stringify(datos)) : null;
      this.previewOpened = true;
    },
    cancelar: function () {
      this.readonly = true;
      // Se recarga del servidor para descartar los cambios en curso.
      if (this.$refs.rform && this.id) this.$refs.rform.loadItem(this.id);
    },
    deleteItem: function () {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(self.$t("rlist.pregunta_eliminar_registro"), "Eliminar", function () {
        Ayuda.delete({ itemId: self.id })
          .then(function (res) {
            if (res) {
              Ayuda.invalidarCache();
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: self.$t("rlist.registro_eliminado"),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
              self.$f7router.back();
            }
          })
          .catch(function (error) {
            app.dialog.alert(error.message);
          });
      });
    },
    onSave: function (res) {
      var self = this;
      var app = self.$f7;
      var esAlta = !self.id;
      Ayuda.invalidarCache();
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast
        .create({
          text: "Ayuda guardada correctamente",
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
      if (esAlta && res && res.id) self.$f7router.navigate("/ayudas/view/" + res.id + "/");
    }
  }
};
</script>
